module.exports = __webpack_public_path__ + "img/img-1.54fd4cac.png";